import React from "react";

/**
 * StatusBadge — uniform pill for operational / account / delay / generic statuses.
 * Brutalist border + colored background. Mirrors LiveTracking's StatusPill.
 */
export const STATUS_TONES = {
  // delay statuses
  ON_TIME: { bg: "bg-emerald-500", text: "text-white", dot: "bg-emerald-300", label: "À l'heure" },
  LATE_1_MIN: { bg: "bg-yellow-400", text: "text-zinc-900", dot: "bg-yellow-600", label: "Retard léger" },
  LATE_3_MIN: { bg: "bg-orange-500", text: "text-white", dot: "bg-orange-300", label: "Retard important" },
  CRITICAL: { bg: "bg-red-500", text: "text-white", dot: "bg-red-200", label: "Critique", pulse: true },
  // generic tones
  success: { bg: "bg-emerald-500", text: "text-white", dot: "bg-emerald-200" },
  warning: { bg: "bg-orange-500", text: "text-white", dot: "bg-orange-200" },
  danger: { bg: "bg-red-500", text: "text-white", dot: "bg-red-200" },
  info: { bg: "bg-blue-500", text: "text-white", dot: "bg-blue-200" },
  yellow: { bg: "bg-[#FFC60A]", text: "text-zinc-900", dot: "bg-zinc-900" },
  neutral: { bg: "bg-zinc-100", text: "text-zinc-700", dot: "bg-zinc-400" },
  navy: { bg: "bg-zinc-900", text: "text-white", dot: "bg-[#FFC60A]" },
  muted: { bg: "bg-zinc-50", text: "text-zinc-500", dot: "bg-zinc-300" },
};

export function StatusBadge({ status, tone, label, className = "", withDot = true, size = "md", testId }) {
  const s = STATUS_TONES[status] || STATUS_TONES[tone || "neutral"] || STATUS_TONES.neutral;
  const finalLabel = label ?? s.label ?? status ?? "";
  const sizeCls = size === "sm" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 ${sizeCls} font-bold uppercase tracking-widest border border-zinc-900 ${s.bg} ${s.text} ${className}`}
    >
      {withDot && (
        <span className={`w-1.5 h-1.5 rounded-full ${s.dot} ${s.pulse ? "animate-pulse" : ""}`} />
      )}
      {finalLabel}
    </span>
  );
}
